import { ApplicationEnum } from "~/@types/enums";
import buildMinimalRailShell from "~/components/dock/minimalRailShell";

const intelligenceRail = buildMinimalRailShell(
	ApplicationEnum.INTELLIGENCE,
	[
		{ icon: "dashboard", id: "dashboard", path: "/intelligence/dashboard", title: "Dashboard" },
		{ icon: "summarize", id: "research", path: "/intelligence/research", title: "Research" },
		{ icon: "search", id: "explorer", path: "/intelligence/explorer", title: "Explorer" },
		{ icon: "description", id: "reports", path: "/intelligence/reports", title: "Reports" }
	],
	"insights"
);

export default intelligenceRail;
